<template>
  <div v-if="!isTennis" class="momentum-container">
    <!-- Broadcast scoreboard: everything centred on the score, team names
         hugging it from each side, a kit-colour tick under each digit. -->
    <div class="momentum-top-bar">
      <div class="team home">
        <LogoCompetitors :team-id="matchData.home_id" height="16px" width="16px" class="team-logo"/>
        <span class="team-name">{{ matchData.home }}</span>
      </div>
      <div class="score-block" :title="periodLabel">
        <div class="score-digits">
          <span class="score-digit">{{ homeScore }}</span>
          <span class="score-digit">{{ awayScore }}</span>
        </div>
        <div class="score-colors">
          <span class="score-color score-color--home"></span>
          <span class="score-color score-color--away"></span>
        </div>
      </div>
      <div class="team away">
        <span class="team-name">{{ matchData.away }}</span>
        <LogoCompetitors :team-id="matchData.away_id" height="16px" width="16px" class="team-logo"/>
      </div>
    </div>
  </div>
</template>

<script>
  import LogoCompetitors from "@/components/center_widgets/LogoCompetitors.vue";

  export default {
    components: {
      LogoCompetitors
    },
    props: {
      initialSportId: { type: [String, Number], required: true },
      eventId: { type: [String, Number], required: true },
      matchData: { type: Object,  required: true }
    },
    computed: {
      ls() { return this.matchData && (this.matchData.Livescore || this.matchData.livescore) ? (this.matchData.Livescore || this.matchData.livescore) : null },
      isTennis() { return parseInt(this.matchData && this.matchData.Fixture && this.matchData.Fixture.Sport ? this.matchData.Fixture.Sport.Id : (this.matchData && this.matchData.sportId ? this.matchData.sportId : 0)) === 54094 || String(this.matchData?.sportId || '') === '265917' },

      isDarts() {
        return String(this.matchData?.sportId || this.initialSportId || '') === '154923';
      },
      // Where the score lives. Darts: the scoreboard only counts sets (0-0 in
      // a legs-only match), the legs are in the set period (type 1, or the
      // set being played).
      scoreResults() {
        const sb = this.ls && (this.ls.Scoreboard || this.ls.scoreboard);
        if (this.isDarts) {
          const periods = (this.ls && (this.ls.Periods || this.ls.periods)) || [];
          const current = String(sb && (sb.CurrentPeriod ?? sb.currentPeriod));
          const typeOf = p => String(p.Type ?? p.type);
          const period = periods.find(p => typeOf(p) === current && parseInt(current) < 60) || periods.find(p => typeOf(p) === '1');
          if (period) return period.Results || period.results || [];
        }
        return sb && (sb.Results || sb.results) || [];
      },
      homeScore() {
        const r = this.scoreResults.find(x => String(x.Position || x.position) == "1");
        return r ? (r.Value ?? r.value ?? 0) : 0;
      },
      awayScore() {
        const r = this.scoreResults.find(x => String(x.Position || x.position) == "2");
        return r ? (r.Value ?? r.value ?? 0) : 0;
      },
      periodLabel() {
        const sb = this.ls && (this.ls.Scoreboard || this.ls.scoreboard);
        const p = String(sb && (sb.CurrentPeriod || sb.currentPeriod));
        const map = { "10": "statistics.1t", "20": "statistics.2t", "100": "statistics.fin", "1": "statistics.s1", "2": "statistics.s2", "3": "statistics.s3" };
        return p && map[p] ? this.$t(map[p]) : this.$t('statistics.live');
      },
    }
  }
</script>

<style scoped>

.momentum-top-bar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  column-gap: 18px;
  padding: 6px 12px 0;
  background: var(--bg-body);
}

.team {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  font-size: var(--font-size-2xl);
  font-weight: 800;
}
.team.home { justify-content: flex-end; }
.team.away { justify-content: flex-start; }
.team .team-logo { width: 16px; height: 16px; object-fit: contain; flex-shrink: 0; }
.team .team-name { color: var(--text-platform); overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-weight: bolder }

.score-block { display: flex; flex-direction: column; align-items: center; }
.score-digits { display: flex; gap: 14px; }
.score-digit {
  min-width: 18px; text-align: center;
  font-size: var(--font-size-7xl, 22px); font-weight: 900; line-height: 1.1;
  color: #facc15; font-variant-numeric: tabular-nums;
}
.score-colors { display: flex; gap: 2px; margin-top: 6px; }
.score-color { width: 22px; height: 2px; }
.score-color--home { background: var(--color-home, #1e88e5); }
.score-color--away { background: var(--color-away, #fff); }

</style>
